<template>
  <div :class="columnClassName">
    <column-header :activeLayout="activeLayout" :columns="columns" :columnIndex="columnIndex" :components="components" :activeComponent="component" v-on:setActiveComponent="setActiveComponent"></column-header>
    <div>
      <div class="row">
        <div class="col-md-12">
          <h3><i class="fa fa-fw fa-file-text-o"></i> {{ _('Content') }}</h3>
        </div>
      </div>
      <div class="row">
        <div class="col-md-3 col-sm-6 filtercol">
          <div class="form-group">
            <div class="input-group">
              <input class="form-control" id="searchField" type="text" v-model="search" :placeholder="_('Keyword search')" />
              <span class="input-group-btn">
                <button type="button" class="btn btn-success"><i class="fa fa-fw fa-search"></i></button>
              </span>
            </div>
          </div>
        </div>
        <div class="col-md-3 col-sm-6 filtercol">
          <div class="form-group">
            <div class="input-group">
              <div class="input-group-addon">{{ _('Display') }}</div>
              <select class="form-control" id="contentTypeFilter" v-model="type">
                <option value="all">{{ _('All content') }}</option>
              </select>
            </div>
          </div>
        </div>
        <div class="col-md-4 col-sm-6 filtercol">
        </div>
        <div class="col-md-2 col-sm-6 filtercol">
          <button class="pull-right newSelector btn btn-success addbutton" type="button" v-on:click="newSelector"><i class="fa fa-fw fa-plus"></i> {{ _('Create new...') }}</button>
        </div>
      </div>
      <Datatable :url="contentUrl" :search="search" :type-filter="type" :options="tableOptions" ref="datatable" v-on:data="tableEvent" />
    </div>
  </div>
</template>

<script>

import axios from 'axios'
import components from '~/lib/components'
import { ContentTypeSelector, Datatable } from '#components'
import formatters from '~/lib/formatters'
import debounce from 'lodash/debounce'

export default {
  data () {
    const $this = this
    const _ = useNuxtApp().$translate
    return {
      content: [],
      search: '',
      type: 'all',
      tableOptions: {
        responsiveLayoutCollapseFormatter: $this.collapseFormatter(),
        columns: [
        {
          title: 'ID',
          field: 'id',
          width: 60,
          responsive: 0
        },
        {
          title: _('Name'),
          field: 'name',
          widthGrow: 5,
          responsive: 0
        },
        {
          title: _('Type'),
          field: 'type',
          widthGrow: 4,
          formatter: $this.contentTypeFormatter()
        }
        ],
        initialSort: [{
          column: 'type',
          dir: 'asc'
        }],
        rowClick (e, row) {
          $this.editRow(row)
        }
      }
    }
  },
  mixins: [components, formatters],
  computed: {
    contentUrl () {
      return this.baseDomain + this.shopId + '/cmscontent.json?apikey=' + this.apiKey + this.versionStr
    },
    showFilters () {
      return false
    }
  },
  methods: {
    editRow (row) {
      let id = row.getCell('id').getValue()
      let name = row.getCell('name').getValue()
      this.editContent(id, name)
    },
    editContent (id, name, skipState) {
      this.EventBus.$emit('showDetailsColumn', {
        shopId: this.shopId,
        component: 'ContentDetails',
        title: this._('Content') + ' ' + id + (name ? ': ' + name : ''),
        width: 6,
        data: {
          contentId: id
        },
        skipState
      })
    },
    async newSelector () {
      this.showModal('contenttypeselector', ContentTypeSelector, {
        props: {
        },
        events: {
          selected: this.createNew
        },
        handlers: {},
        width: 800
      })
    },
    async createNew (data) {
      let response
      let d = {
        name: data.name,
        type: data.type
      }
      try {
        response = await axios.post(this.baseDomain + this.shopId + '/cmscontent.json?apikey=' + this.apiKey, d)
        if (response.data) {
          this.editContent(response.data)
        }
      } catch(e) {}
    },
    reload (url) {
      this.$refs.datatable.reload(url)
    }
  },
  components: {
    Datatable
  },
  mounted () {
    if(!this.events) {
      let events = {}
      events['cmscontentUpdate'] = debounce((message) => {
        return this.reload()
      }, 200)
      events['restoreDetails'] = (message) => {
        if (message.shopId !== this.shopId) {
          return
        }
        switch(message.component) {
          case 'ContentDetails':
            this.editContent(message.data.contentId, null, true)
            break
        }
      }
      this.events = events
    }
    this.enableEventBus()
  }

}

</script>